/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctorAvailabilities } from 'app/entities/doctor-availability/doctor-availability.reducer';
import { createEntity, getEntity, reset, updateEntity } from './doctor-availability-slot.reducer';

export const DoctorAvailabilitySlotUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctorAvailabilities = useAppSelector(state => state.doctorAvailability.entities);
  const doctorAvailabilitySlotEntity = useAppSelector(state => state.doctorAvailabilitySlot.entity);
  const loading = useAppSelector(state => state.doctorAvailabilitySlot.loading);
  const updating = useAppSelector(state => state.doctorAvailabilitySlot.updating);
  const updateSuccess = useAppSelector(state => state.doctorAvailabilitySlot.updateSuccess);

  const handleClose = () => {
    navigate(`/doctor-availability-slot${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctorAvailabilities({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.startTime !== undefined && typeof values.startTime !== 'number') {
      values.startTime = Number(values.startTime);
    }
    if (values.endTime !== undefined && typeof values.endTime !== 'number') {
      values.endTime = Number(values.endTime);
    }

    const entity = {
      ...doctorAvailabilitySlotEntity,
      ...values,
      availability: doctorAvailabilities.find(it => it.id.toString() === values.availability?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...doctorAvailabilitySlotEntity,
          availability: doctorAvailabilitySlotEntity?.availability?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.doctorAvailabilitySlot.home.createOrEditLabel" data-cy="DoctorAvailabilitySlotCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.home.createOrEditLabel">
              Create or edit a DoctorAvailabilitySlot
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="doctor-availability-slot-id"
                  label={translate('tinyMedicRestApp.doctorAvailabilitySlot.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailabilitySlot.timestampEntry')}
                id="doctor-availability-slot-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailabilitySlot.microSec')}
                id="doctor-availability-slot-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailabilitySlot.lastupdated')}
                id="doctor-availability-slot-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailabilitySlot.active')}
                id="doctor-availability-slot-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailabilitySlot.cursor')}
                id="doctor-availability-slot-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailabilitySlot.startTime')}
                id="doctor-availability-slot-startTime"
                name="startTime"
                data-cy="startTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailabilitySlot.endTime')}
                id="doctor-availability-slot-endTime"
                name="endTime"
                data-cy="endTime"
                type="text"
              />
              <ValidatedField
                id="doctor-availability-slot-availability"
                name="availability"
                data-cy="availability"
                label={translate('tinyMedicRestApp.doctorAvailabilitySlot.availability')}
                type="select"
              >
                <option value="" key="0" />
                {doctorAvailabilities
                  ? doctorAvailabilities.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/doctor-availability-slot" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoctorAvailabilitySlotUpdate;
